import './wdyr';
import * as React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import App from './App';
import { history } from './history';
import credential from './reducers/credential';
import dashboard from './reducers/dashboard';
import logSearch from './reducers/logsearch';
import logSource from './reducers/logsources';
import listIps from './reducers/listips';
import session, { abortAllRequests } from './reducers/session';
import risk from './reducers/risk';
import onboarding from './reducers/onboarding';
import { Action, Store } from './types';
// Include ES6 polyfills for IE11 :/
import 'react-app-polyfill/ie11';
import 'core-js/stable/array';
import 'core-js/stable/string';
import 'core-js/stable/object';
import 'core-js/stable/number/is-integer';
import 'core-js/stable/number/is-finite';
import '@rtkwlf/fenrir-react/dist/style.css';

const combinedReducers = combineReducers({
  credential,
  dashboard,
  logSearch,
  logSource,
  session,
  risk,
  onboarding,
  listIps,
});

// Root reducer will clear store on 'logout' or 'switch_customer'
// actions, otherwise delegates everything to individual reducers
const RESET_ACTIONS = ['switch_customer', 'logout'];

// rootReducer must know how to handle when storeState is undefined
export const rootReducer = (storeState: Store | undefined, action: Action) => {
  let currentState = storeState;
  if (currentState && RESET_ACTIONS.includes(action.type)) {
    abortAllRequests(currentState);
    currentState = undefined;
  }
  return combinedReducers(currentState, action);
};

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk)),
);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'),
);
